// extracted by mini-css-extract-plugin
export default {"LoggedInWelcome":"LoggedInWelcome_LoggedInWelcome__pHfsb","GradientBlock":"LoggedInWelcome_GradientBlock__z9-Fl"};